import { createSvgIcon } from '@mui/material';

export const PayPalIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19685_71113)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#E7EBFA'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.7818 12.5007H14.7385C14.5987 12.5007 14.4798 12.6024 14.458 12.7403L13.6315 17.9794C13.6151 18.0828 13.6952 18.176 13.8001 18.176H14.7756C14.9154 18.176 15.0343 18.0744 15.0561 17.9361L15.279 16.5231C15.3005 16.3847 15.4197 16.2832 15.5593 16.2832H16.2061C17.5521 16.2832 18.3289 15.6319 18.5319 14.3414C18.6232 13.7768 18.5357 13.3331 18.2712 13.0224C17.9809 12.6813 17.4657 12.5007 16.7818 12.5007ZM17.0176 14.4142C16.9059 15.1474 16.3456 15.1474 15.804 15.1474H15.4956L15.7119 13.7782C15.7248 13.6955 15.7965 13.6345 15.8801 13.6345H16.0215C16.3904 13.6345 16.7386 13.6345 16.9184 13.8448C17.0256 13.9703 17.0585 14.1567 17.0176 14.4142ZM22.8898 14.3907H21.9113C21.8279 14.3907 21.7559 14.4517 21.7431 14.5345L21.6998 14.8081L21.6313 14.709C21.4195 14.4015 20.9472 14.2988 20.4757 14.2988C19.3943 14.2988 18.4709 15.1177 18.291 16.2664C18.1975 16.8393 18.3304 17.3871 18.6555 17.7693C18.9537 18.1206 19.3804 18.267 19.888 18.267C20.7592 18.267 21.2424 17.7068 21.2424 17.7068L21.1987 17.9787C21.1823 18.0827 21.2623 18.1759 21.3666 18.1759H22.248C22.3882 18.1759 22.5064 18.0742 22.5285 17.936L23.0574 14.5873C23.0741 14.4843 22.9943 14.3907 22.8898 14.3907ZM21.5258 16.295C21.4314 16.8539 20.9877 17.2291 20.4219 17.2291C20.1378 17.2291 19.9106 17.138 19.7649 16.9653C19.6203 16.7939 19.5652 16.5498 19.6113 16.278C19.6995 15.7237 20.1507 15.3364 20.7079 15.3364C20.9856 15.3364 21.2116 15.4286 21.3603 15.6028C21.5094 15.7788 21.5686 16.0243 21.5258 16.295ZM27.1178 14.3906H28.1012C28.2389 14.3906 28.3192 14.545 28.2409 14.658L24.9706 19.3781C24.9176 19.4545 24.8304 19.5 24.7372 19.5H23.7551C23.6168 19.5 23.5361 19.3443 23.6161 19.2311L24.6344 17.7939L23.5514 14.6158C23.5139 14.5053 23.5955 14.3906 23.713 14.3906H24.6792C24.8048 14.3906 24.9155 14.473 24.9518 14.5931L25.5265 16.5126L26.8828 14.5152C26.9359 14.4372 27.0241 14.3906 27.1178 14.3906Z'
        fill='#253B80'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.7793 17.9789L38.6178 12.6441C38.6307 12.5612 38.7025 12.5003 38.7858 12.5H39.7299C39.8342 12.5 39.9142 12.5935 39.8978 12.6969L39.0708 17.9357C39.0492 18.0739 38.9303 18.1755 38.7903 18.1755H37.9471C37.8429 18.1755 37.7628 18.0823 37.7793 17.9789ZM31.357 12.5003H29.3133C29.1738 12.5003 29.0549 12.6019 29.033 12.7399L28.2066 17.9789C28.1902 18.0823 28.2702 18.1755 28.3746 18.1755H29.4232C29.5207 18.1755 29.6041 18.1045 29.6193 18.0077L29.8538 16.5226C29.8754 16.3842 29.9945 16.2828 30.1341 16.2828H30.7806C32.1269 16.2828 32.9035 15.6315 33.1066 14.3409C33.1983 13.7763 33.1102 13.3327 32.8458 13.0219C32.5556 12.6808 32.0409 12.5003 31.357 12.5003ZM31.5927 14.4138C31.4813 15.1469 30.9211 15.1469 30.3791 15.1469H30.071L30.2877 13.7777C30.3005 13.695 30.3716 13.6341 30.4555 13.6341H30.5968C30.9656 13.6341 31.314 13.6341 31.4937 13.8443C31.601 13.9699 31.6337 14.1562 31.5927 14.4138ZM37.4644 14.3903H36.4866C36.4026 14.3903 36.3312 14.4512 36.3186 14.5341L36.2754 14.8076L36.2066 14.7085C35.9948 14.4011 35.5228 14.2983 35.0513 14.2983C33.9699 14.2983 33.0467 15.1172 32.8669 16.2659C32.7737 16.8388 32.906 17.3867 33.231 17.7688C33.5298 18.1201 33.956 18.2665 34.4635 18.2665C35.3347 18.2665 35.8178 17.7063 35.8178 17.7063L35.7743 17.9782C35.7578 18.0822 35.8379 18.1754 35.9428 18.1754H36.8239C36.9634 18.1754 37.0823 18.0738 37.1041 17.9355L37.6333 14.5869C37.6494 14.4839 37.5694 14.3903 37.4644 14.3903ZM36.1006 16.2945C36.0067 16.8535 35.5625 17.2287 34.9966 17.2287C34.713 17.2287 34.4854 17.1376 34.3395 16.9649C34.1949 16.7935 34.1406 16.5493 34.186 16.2775C34.2747 15.7233 34.7253 15.3359 35.2825 15.3359C35.5604 15.3359 35.7862 15.4281 35.9351 15.6023C36.0847 15.7783 36.1439 16.0238 36.1006 16.2945Z'
        fill='#179BD7'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19685_71113'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19685_71113'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19685_71113'
          result='effect2_dropShadow_19685_71113'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19685_71113'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'PayPalIcon',
);
